import styled from 'styled-components';

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 6px;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
  ${(props) => props.border && 'border: 1px solid rgba(128, 128, 128, 0.6);'}
`;

export const Label = styled.label`
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
`;

export const Input = styled.input`
  border: none;
  height: 30px;
  outline: none;
  color: black;
  font-weight: 600;
`;

export const DropzoneWrapper = styled.div`
  overflow-x: auto;
  display: flex;
  flex-direction: row;
  margin-top: 4px;
  gap: 12px;
  white-space: nowrap;
`;

export const DropzoneContent = styled.div`
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  pointer-events: none;
  gap: 8px;
`;

export const WrapperConfirmModal = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  width: 100%;
  gap: 16px;
`;

export const ButtonRemoveImage = styled.button`
  width: '100%';
  border: '1px solid #52525b';
  background-color: 'transparent';
  color: '#52525b';
  cursor: 'pointer';
  &:hover {
    transition: 'background 0.3s';
    background-color: '#52525b';
    color: '#fff';
  }
`;
